import { motion } from "framer-motion";
import { DiscordLogo, ArrowRight } from "@phosphor-icons/react";
import { SOCIALS } from "../config/socials";

export const DiscordCTA = () => {
    return (
        <section className="relative py-10 lg:py-14" data-testid="discord-cta-section">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="relative rounded-2xl border border-white/10 bg-obsidian-900/60 p-8 lg:p-10 flex flex-col lg:flex-row items-start lg:items-center gap-6"
                    data-testid="discord-cta"
                >
                    <div className="h-14 w-14 rounded-xl bg-indigo-500/15 border border-indigo-500/30 flex items-center justify-center shrink-0">
                        <DiscordLogo size={26} weight="fill" className="text-indigo-300" />
                    </div>
                    <div className="flex-1">
                        <div className="eyebrow text-indigo-300/70">Discord</div>
                        <h3 className="font-display text-2xl text-white mt-1">Step into the ool server.</h3>
                        <p className="text-white/55 mt-2 max-w-xl text-sm">
                            Chat between streams, drop your clips, hit up the mods, and find out about every meltdown before anyone else.
                        </p>
                        <div className="mt-2 text-[11px] font-mono text-white/40">
                            {SOCIALS.discord.handle}
                        </div>
                    </div>
                    <a
                        href={SOCIALS.discord.url}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-sweep inline-flex items-center gap-2 px-5 py-3 rounded-full bg-indigo-500 hover:bg-indigo-400 text-white text-sm font-semibold transition-colors"
                        data-testid="discord-join-btn"
                    >
                        Join the Discord <ArrowRight size={14} weight="bold" />
                    </a>
                </motion.div>
            </div>
        </section>
    );
};
